module.exports = __webpack_public_path__ + "static/colgadas-008.thumb-cffd3e4b1f0c7fca9a30596d5de117b4.jpg";